import { useEffect, useRef } from "react";
import { useInput, useChoicesContext, AutocompleteInput, SelectInput } from "react-admin";

// onValueChange(value) fires on every value change, including the auto-pick (which doesn't
// trigger the input's onChange), so callers can sync derived state from it.
const AutoPickSelectInput = ({ onValueChange, ...props }) => {
  const { field } = useInput(props);
  const { allChoices, isLoading } = useChoicesContext();

  // Keep the latest callback in a ref so inline arrows don't retrigger the effect.
  const onValueChangeRef = useRef(onValueChange);
  onValueChangeRef.current = onValueChange;

  useEffect(() => {
    onValueChangeRef.current?.(field.value ?? null);
  }, [field.value]);

  const hasBeenAutocomplete = useRef(false);
  if (allChoices?.length > 3) {
    hasBeenAutocomplete.current = true;
  }
  const isAutocomplete = hasBeenAutocomplete.current;

  useEffect(() => {
    if (!isAutocomplete && !isLoading && allChoices?.length === 1 && !field.value) {
      field.onChange(allChoices[0]?.id);
    }
  }, [allChoices, isLoading, isAutocomplete, field]);

  if (isAutocomplete) {
    // AutocompleteInput passes emptyText straight to translate(), which throws on a non-string
    // (e.g. the emptyText={false} used to suppress the empty option in SelectInput). Drop it —
    // an undefined emptyText renders no empty option either, which is the intent anyway.
    const { emptyText, ...autocompleteProps } = props;
    return (
      <AutocompleteInput
        {...autocompleteProps}
        emptyText={typeof emptyText === "string" ? emptyText : undefined}
      />
    );
  }

  return <SelectInput {...props} />;
};

export default AutoPickSelectInput;
